import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { Button } from '../ui/Button';
export function DVHero() {
  return <section className="relative pt-[120px] pb-[60px] lg:pt-[160px] lg:pb-[100px] overflow-hidden min-h-[500px] lg:min-h-[70vh] flex items-center" data-id="element-1022">
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/mVjnxkGpjowYXqHJiRHctY/weight-loss-for-women.jpg)'
    }} data-id="element-1023" />
      <div className="absolute inset-0 bg-black/60" data-id="element-1024" />

      <div className="max-w-[1200px] mx-auto px-6 lg:px-8 w-full relative z-10" data-id="element-1025">
        <AnimateOnScroll className="w-full lg:w-[60%]" data-id="element-1026">
          <div className="mb-6" data-id="element-1027">
            <span className="text-[#999999] text-[13px] font-body" data-id="element-1028">
              <a href="/treatments" className="hover:text-[#FF1493] transition-colors" data-id="element-1029">
                Treatments
              </a>{' '}
              / Lasers
            </span>
          </div>

          <span className="text-[#FF1493] uppercase text-sm font-bold tracking-[3px] mb-4 block font-[Poppins,_sans-serif]" data-id="element-1030">
            Be FEMININE
          </span>

          <h1 className="text-[28px] sm:text-5xl lg:text-[52px] uppercase text-white tracking-tight mb-2 font-[600] font-[Poppins,_sans-serif] leading-none" data-id="element-1031">
            DIVA VAGINAL REJUVENATION LASER
          </h1>

          <p className="font-serif italic text-white/80 text-xl lg:text-2xl mb-8 mt-3" data-id="element-1032">
            in a nutshell
          </p>

          <div className="space-y-6" data-id="element-1033">
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-1034">
              For women experiencing post-pregnancy or menopause symptoms like
              lack of lubrication, urinary incontinence, painful intercourse or
              vaginal irritation, it can significantly impact your quality of
              life and overall well-being.
            </p>
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-1035">
              From discomfort to embarrassment to a loss of confidence in
              intimate situations, these symptoms can cause women to feel
              disconnected from their bodies. At Be CLINICAL, we are proud to
              offer our patients diVa, a safe and effective vaginal rejuvenation
              laser treatment.
            </p>
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-1036">
              DiVa is just one of the many services we offer at Be CLINICAL as
              part of our feminine wellness suite of services. Other services
              include O-Shot, BHRT (bioidentical hormone replacement therapy),
              stem cell therapy, labial puffing, vaginal tightening and libido
              enhancement. Together with Dr. Fiona, who oversees our wellness
              program, women of all ages can rediscover the confidence they
              desire.
            </p>
          </div>

          <Button variant="primary" size="lg" className="mt-8 w-full sm:w-auto" data-id="element-1037">
            SCHEDULE CONSULTATION
          </Button>
        </AnimateOnScroll>
      </div>
    </section>;
}